module.exports = __webpack_public_path__ + "static/img/zzhjjy.0cde9410.png";